import apiCall from '../index'

const apiService = '/api-seguimiento/api/v1/objetivo'

const service = {
  findAll(params) {
    const query = `?idtipoObjetivo=${params.idtipoObjetivo}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(`${apiService}${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
